import { useState } from "react";
import { CalendarX2, Search } from "lucide-react";
import { useFetch } from "@/lib/api";
import { usePageMeta, PageHeader, EmptyState, Loader, ErrorState, Pagination } from "@/components/common";
import { EventCard } from "@/components/EventCard";
import { EVENT_STATUS } from "@/lib/format";

export default function Events() {
  usePageMeta("Eventi", "Calendario e archivio degli eventi competitivi NEXUM LEGACY.");
  const [f, setF] = useState({ page: 1 });
  const meta = useFetch("/events-meta");
  const { data, loading, error, reload } = useFetch("/events", f);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v || undefined, page: 1 }));
  const statuses = Object.entries(EVENT_STATUS).filter(([k]) => k !== "bozza");
  return (
    <div data-testid="events-page">
      <PageHeader eyebrow="Competizioni" title="Eventi" subtitle="Tornei, leghe e sfide ufficiali dell'alleanza." />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-10">
        <div className="flex flex-wrap gap-2.5 mb-8">
          <div className="relative flex-1 min-w-[220px]">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#C6C6CE]/40" />
            <input data-testid="events-search" placeholder="Cerca evento" className="nx-input pl-9" onChange={(e) => set("q", e.target.value)} />
          </div>
          <select data-testid="events-filter-status" aria-label="Stato" className="nx-input w-auto" onChange={(e) => set("status", e.target.value)}>
            <option value="">Tutti gli stati</option>{statuses.map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <select data-testid="events-filter-mode" aria-label="Modalità" className="nx-input w-auto" onChange={(e) => set("mode", e.target.value)}>
            <option value="">Tutte le modalità</option>{(meta.data?.modes || []).map((m) => <option key={m}>{m}</option>)}
          </select>
          <select data-testid="events-filter-format" aria-label="Formato" className="nx-input w-auto" onChange={(e) => set("format", e.target.value)}>
            <option value="">Tutti i formati</option>{(meta.data?.formats || []).map((m) => <option key={m}>{m}</option>)}
          </select>
          <input data-testid="events-filter-from" type="date" aria-label="Dal" className="nx-input w-auto" onChange={(e) => set("date_from", e.target.value)} />
          <input data-testid="events-filter-to" type="date" aria-label="Al" className="nx-input w-auto" onChange={(e) => set("date_to", e.target.value && `${e.target.value}T23:59:59`)} />
        </div>
        {error ? <ErrorState message={error} onRetry={reload} /> : loading && !data ? <Loader /> : data.items.length ? (
          <>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{data.items.map((e, i) => <EventCard key={e.id} ev={e} index={i} />)}</div>
            <Pagination page={data.page} pages={data.pages} onChange={(p) => setF((x) => ({ ...x, page: p }))} />
          </>
        ) : <EmptyState icon={CalendarX2} title="Nessun evento trovato" text="Modifica i filtri o torna più tardi." />}
      </div>
    </div>
  );
}
